<template lang="html">
  <div class="student">
    <Header :openTarget="'invite/connect?name='+ name" />

    <div>
      <!-- <img class="modImg" :src="`${pagebase}/static/img/cst/banner.png`" alt=""> -->
      <img class="modImg" src="../../assets/image/specialistNo1.png" alt="">
      <div class="tabHeader">
        <div class="tabCon">
          <ul class="tabMod">
            <li class="tabChild" @click="cur = 0" :class="{activeNo1:cur == 0}">
              去关联:个人&专家
            </li>
            <li class="tabChild" @click="cur = 1" :class="{activeNo2:cur == 1}">
              被关联:企业&高校
            </li>
          </ul>
        </div>
      </div>
      <div v-show="cur == 0">
        <img class="modImg" :src="`${pagebase}/static/img/student/specialist/specialistNo1.png`" alt="">
        <img class="modImg" :src="`${pagebase}/static/img/student/specialist/specialistNo2.png`" alt="">
        <img class="modImg" :src="`${pagebase}/static/img/student/specialist/specialistNo3.png`" alt="">
        <img class="modImg" :src="`${pagebase}/static/img/student/specialist/specialistNo4.png`" alt="">
      </div>
      <div v-show="cur == 1">
        <img class="modImg" :src="`${pagebase}/static/img/student/enterprise/enterpriseNo1.png`" alt="">
        <img class="modImg" :src="`${pagebase}/static/img/student/enterprise/enterpriseNo2.png`" alt="">
        <img class="modImg" :src="`${pagebase}/static/img/student/enterprise/enterpriseNo3.png`" alt="">
        <img class="modImg" :src="`${pagebase}/static/img/student/enterprise/enterpriseNo4.png`" alt="">
        <img class="modImg" :src="`${pagebase}/static/img/student/enterprise/enterpriseNo5.png`" alt="">
      </div>

      <div class="footerMod">
        <p class="hintNo1">你可以这样联系我</p>
        <p class="hintNo2">有任何疑问 可以添加企业微信联系我们</p>
        <img class="hintImg" :src="`${pagebase}/static/img/student/ma.jpg`" alt="">
      </div>
    </div>

    <div class="relevanceBtn">
      {{cur ? "邀请TA关联" : "立即关联TA"}}
      <WxOpenTag ref="wxopentag" :extinfo="'invite/connect?name=' + name" />
    </div>
  </div>
</template>

<script>
  import Header from '@/components/HeadModule';
  import WxOpenTag from '@/components/WxOpenTag';
  import {pagebase} from '@/utils/http.js';
  import WxShare from '@/utils/wxshare';

  export default {
    data() {
      return {
        name: this.$route.query.name || '',
        pagebase: pagebase,
        cur: 0,
      }
    },

    components: {
      Header,
      WxOpenTag,
    },

    mounted() {
      new WxShare().share({
        title: this.name + '邀请你关联企业高校号',
        desc: '企业关联员工，高校关联师生，一键直达关联企业号',
        link: window.location.href,
        imgUrl: pagebase + '/static/img/student/enterprise/share.png',
      })
    },
  }
</script>

<style lang="css" scoped>
  .student {
    background-color: #072480;
    padding-bottom: 11rem;
  }

  .modImg {
    width: 100%;
  }

  .tabHeader {
    width: 100%;
    box-sizing: border-box;
    padding: 0 1.5rem;
    background-color: #072480;
    margin-top: -.5rem;
  }

  .tabCon {
    background-color: #FFF;
    padding: 1.5rem .85rem;
    border-radius: 1.5rem 1.5rem 0 0;
  }

  .tabMod {
    width: 100%;
    height: 4.5rem;
    box-sizing: border-box;
    display: flex;
    border-radius: 4.5rem;
    background-color: #E2E6FF;
  }

  .tabChild {
    position: relative;
    width: 50%;
    border-radius: 4.5rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-size: 1.5rem;
    color: #7282B5;
    z-index: 2;
  }

  .activeNo1::after {
    content: '去关联:个人&专家';
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    width: 100%;
    height: 4.5rem;
    line-height: 4.5rem;
    font-size: 1.5rem;
    font-weight: 600;
    border-radius: 4.5rem;
    background-color: #14298E;
    color: #FFF;
    z-index: 1;
  }

  .activeNo2:after {
    content: '被关联:企业&高校';
    position: absolute;
    left: 0;
    top: 0;
    text-align: center;
    width: 100%;
    height: 4.5rem;
    line-height: 4.5rem;
    font-size: 1.5rem;
    font-weight: 600;
    border-radius: 4.5rem;
    background-color: #14298E;
    color: #FFF;
    z-index: 1;
  }

  .relevanceBtn {
    position: fixed;
    bottom: 3.5rem;
    left: 50%;
    width: 33.7rem;
    height: 4.9rem;
    line-height: 4.9rem;
    border-radius: 4.9rem;
    text-align: center;
    margin-left: -16.85rem;
    font-size: 1.8rem;
    color: #FFF;
    background: linear-gradient(to right, #F62A3E, #E60001);
  }

  .footerMod {
    background-color: #072480;
    margin-top: -.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 2.75rem;
  }

  .hintNo1 {
    font-size: 2rem;
    color: #FFF;
  }

  .hintNo2 {
    font-size: 1.3rem;
    color: #FFF;
    margin-top: .4rem;
  }

  .hintImg {
    width: 11rem;
    height: 11rem;
    margin-top: 2rem;
  }
</style>
